import router from "./router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Message } from "element-ui";
import { Route } from "vue-router";
import { UserModule } from "@/store/modules/user";
import { PermissionModule } from "@/store/modules/permission";
import settings from "./settings";
import text from "./lang/zh";

NProgress.configure({ showSpinner: false });

const whiteList = ["/login", "/auth-redirect"];

const getPageTitle = () => {
  const pageName = text.route.dashboard;
  return `${pageName} - ${settings.title}`;
};

router.beforeEach(async(to: Route, _: Route, next: any) => {
  // Start progress bar
  NProgress.start();
  // Determine whether the user has logged in
  if (UserModule.token) {
    if (to.path === "/login") {
      // If is logged in, redirect to the home page
      next({ path: "/" });
      NProgress.done();
    } else {
      // Check whether the user has obtained his permission roles
      if (UserModule.roles.length === 0) {
        try {
          // Note: roles must be a object array! such as: ['admin'] or ['developer', 'editor']
          await UserModule.GetUserInfo();
          await UserModule.GetUserPermissions();
          // Generate accessible routes map based on role
          PermissionModule.GenerateRoutes(UserModule.routes);
          // Dynamically add accessible routes
          PermissionModule.dynamicRoutes.forEach((route) => {
            router.addRoute(route);
          });
          // Hack: ensure addRoutes is complete
          // Set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true });
        } catch (err) {
          // Remove token and redirect to login page
          UserModule.ResetToken();
          Message.error(err || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      } else {
        const routerList = PermissionModule.routes
        const allNames = extractNames(routerList)
        if( allNames.indexOf(to.name) === -1 ) {
          next({ name: '401',path: '/401' })
        } else {
          next()
        }
      }
    }
  } else {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next();
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

const extractNames = (routes) => {
  let names = [];
  // 遍历每个路由
  routes.forEach(route => {
    // 添加当前路由的 name
    names.push(route.name);
    // 如果存在子路由，递归提取子路由的 name
    if (route.children) {
      names = names.concat(extractNames(route.children));
    }
  });
  return names;
}

router.afterEach(() => {
  // Finish progress bar
  // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
  NProgress.done();
  // set page title
  document.title = getPageTitle();
});

// router.beforeEach((to, from, next) => {
//   if (UserModule.token && PermissionModule.routes.length > 0) {

//   }
// })